import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-bstime-picker',
	templateUrl:'./BSTimePickerPage.html',
	styles: [],
	styleUrls:['./BSTimePickerPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BSTimePickerPage
{
	mdContent_167 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.timepicker.BSTimePicker;
\`\`\``;
	mdContent_168 = `\`\`\`java
new BSTimePicker<>()
\`\`\``;
	mdContent_169 = `\`\`\`java
var timePicker = new BSTimePicker<>();
form.add(timePicker);
\`\`\``;
}
